import React from 'react';
import { Star } from 'lucide-react';
interface TextTestimonialProps {
  children: React.ReactNode;
  author: string;
  location: string;
  result?: string;
}
export function TextTestimonial({
  children,
  author,
  location,
  result
}: TextTestimonialProps) {
  return <div className="max-w-3xl mx-auto py-12 px-4 text-center" data-id="element-186">
      <div className="flex justify-center gap-1 mb-6" data-id="element-187">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brand-gold text-brand-gold" data-id="element-188" />)}
      </div>

      <blockquote className="text-xl md:text-2xl lg:text-3xl leading-relaxed text-brand-charcoal font-heading italic mb-8" data-id="element-189">
        "{children}"
      </blockquote>

      <div className="flex flex-col items-center justify-center gap-1" data-id="element-190">
        <p className="font-bold text-brand-charcoal uppercase tracking-wider text-sm" data-id="element-191">
          {author} <span className="text-brand-charcoal/40 mx-2" data-id="element-192">|</span>{' '}
          {location}
        </p>
        {result && <p className="text-brand-sage font-medium mt-2 text-sm md:text-base" data-id="element-193">
            Result: {result}
          </p>}
      </div>
    </div>;
}